import * as React from 'react';
import { safe, isNullOrUndefined, getViewFundList } from "../../utils";
import { IPageProperties, IExplorerProperties, IWatchlist, IDataEntity } from "../../models";

const FaClose = require('react-icons/lib/fa/times-circle');
const styles = require('./AddRemoveButton.pcss');
const FaPlus = require('react-icons/lib/fa/plus');
const FaMinus = require('react-icons/lib/fa/minus');
const FaStarO = require('react-icons/lib/fa/star-o');
const FaStar = require('react-icons/lib/fa/star');

interface IProps {
	shareClass?: IDataEntity;
	isMobile?: boolean;
	buttonStyle?: any;
}

interface IState {
	width?: number;
};

export class AddRemoveButton extends React.Component<IPageProperties & IProps, IState>{
	constructor(props) {
		super(props);
	}

	updateLocalState() {
		this.setState({ width: window.innerWidth });
	}

	componentWillMount() {
		this.updateLocalState();
	}

	handleAddToWatchlist(isRemove: boolean) {
		let { shareClass, appParams } = this.props;
		let watchlistItem = {
			fundName: shareClass.properties.fund_name,
			fundIdentifier: shareClass.properties.fund_key,
			isin: shareClass.clientCode,
		};
		this.props.editWatchlist(watchlistItem, appParams, isRemove, true);
	}

	render() {
		let { watchlist, shareClass, appParams } = this.props;
		let isDTC = appParams.clienttype === "dtc";
		if (isDTC) {
			return null;
		}

		let { width } = this.state;
		let isPrivateInvestor = appParams.clienttype === "pri";
		let watchlistItem = watchlist.filter(item => item.isin === shareClass.clientCode && item.fundList === getViewFundList(appParams));
		if (watchlistItem.length === 0) {
			if (width < 700) {
				return (
					<div>
						<button type="button" onClick={ () => this.handleAddToWatchlist(false) } className={ `${ styles.addToWatchlistMobile } ${ isPrivateInvestor ? styles.addToWatchlistPrivate : "" }` }>
							<span><FaStarO /></span>
						</button>
					</div>
				);
			}
			else {
				return (
					<div>
						<button type="button" onClick={ () => this.handleAddToWatchlist(false) } className={ `${ styles.addToWatchlist } ${ isPrivateInvestor ? styles.addToWatchlistPrivate : "" }` }>
							<span>Add to Watchlist <FaPlus /></span>
						</button>
					</div>
				);
			}
		}
		else {
			if (width < 700) {
				return (
					<div>
						<button type="button" onClick={ () => this.handleAddToWatchlist(true) } className={ `${ styles.addToWatchlistMobile } ${ isPrivateInvestor ? styles.addToWatchlistPrivate : "" }` }>
							<span><FaStar /></span>
						</button>
					</div>
				);
			}
			else {
				return (
					<div>
						<button type="button" onClick={ () => this.handleAddToWatchlist(true) } className={ `${ styles.addToWatchlist } ${ isPrivateInvestor ? styles.addToWatchlistPrivate : "" }` }>
							<span>Remove from Watchlist <FaMinus /></span>
						</button>
					</div>
				);
			}
		}
	}
}




// WEBPACK FOOTER //
// ./src/client/components/Watchlist/AddRemoveButton.tsx